import { useState, useEffect } from 'react';
import { Button } from '../ui/button';
import { FormField, Input, Label } from '../ui/input';
import type { Caixinha } from '../../types';

export interface CaixinhaFormData {
  title: string;
  description?: string;
}

interface CaixinhaFormProps {
  onSubmit: (data: CaixinhaFormData) => Promise<void>;
  onClose?: () => void;
  initialData?: Caixinha | null;
}

export function CaixinhaForm({ onSubmit, onClose, initialData }: CaixinhaFormProps) {
  const [title, setTitle] = useState(initialData?.title ?? '');
  const [description, setDescription] = useState(initialData?.description ?? '');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setTitle(initialData?.title ?? '');
    setDescription(initialData?.description ?? '');
  }, [initialData]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!title.trim()) return;
    setSaving(true);
    try {
      await onSubmit({ title: title.trim(), description: description.trim() || undefined });
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-4">
      <FormField>
        <Label htmlFor="caixinha-title">
          Nome <span className="text-destructive">*</span>
        </Label>
        <Input
          id="caixinha-title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Ex: Poupança emergência"
          required
        />
      </FormField>

      <FormField>
        <Label htmlFor="caixinha-desc">Descrição</Label>
        <Input
          id="caixinha-desc"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Opcional"
        />
      </FormField>

      <div className="flex gap-2">
        {onClose && (
          <Button type="button" variant="outline" className="flex-1" onClick={onClose}>
            Cancelar
          </Button>
        )}
        <Button type="submit" className="flex-1" disabled={!title.trim() || saving}>
          {initialData ? 'Salvar alterações' : 'Criar caixinha'}
        </Button>
      </div>
    </form>
  );
}
